import React, { useEffect, useState } from "react";
import PatientFormService from "../../../services/PatientFormService";
import FormInputs from "../../../components/UI/FormInputs";

const EmrHistoryQuestions = (props) => {
  // const [apiData, setApiData] = useState(null);
  const { apiData ,setApiData } = props;
  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (fieldId, value, isMulti, isSingle, checked) => {
    console.log("handleChange called with:", {
      fieldId,
      value,
      isMulti,
      isSingle,
      checked,
    });
    props.setPatientEmrHistory((prev) => {
      const updated = { ...(prev || {}) }; // ✅ prevents crash

      if (isMulti) {
        // Normalize previous to array of strings
        const raw = updated[fieldId] ?? "";
        const current = Array.isArray(raw)
          ? raw.map((v) => String(v))
          : String(raw)
              .split(",")
              .map((v) => v.trim())
              .filter(Boolean);

        const valStr = String(value);

        if (checked) {
          if (!current.includes(valStr)) current.push(valStr);
        } else {
          const idx = current.indexOf(valStr);
          if (idx !== -1) current.splice(idx, 1);
        }

        updated[fieldId] = current.length ? current.join(",") : "";
      } else if (isSingle) {
        updated[fieldId] = value;
      } else {
        updated[fieldId] = value;
      }

      return updated;
    });
  };

  const fetchData = async () => {
    let response = await PatientFormService.getFullHistoryFormsById(
     props.patientFormData.organization_id, props.patientFormData.visit_id
    );
    console.log("response from emr history questions", response);
    setApiData(response);

    // 🔽 Add this normalization here
    const allSubTabs = response?.data?.original?.data?.sub_tabs || [];
    let mergedState = {};

    allSubTabs.forEach((tab) => {
      tab?.forms?.forEach((form) => {
        form?.fields?.forEach((field) => {
          const saved = field?.saved_data;
          // console.log("saved data for field", field.id, saved);
          if (!saved) return;

          // mergedState[field.id] = mergedState[field.id] || {};
          switch (field?.field_type?.input_type) {
            case "TEXT_FIELD":
            case "TEXT_AREA": {
              let textValue = saved;
              // convert to string safely
              if (textValue === null || textValue === undefined) textValue = "";
              else textValue = String(textValue);
              handleChange(field.id, textValue);
              break;
            }
            case "SINGLE_SELECT":
              handleChange(field.id, saved, false, true, true);
              break;
            case "DATE":
              handleChange(field.id, saved);
              break;
            case "MULTI_SELECT":
              if (Array.isArray(saved)) {
                saved.forEach((val) => {
                  handleChange(field.id, val, true, false, true);
                });
              } else if (typeof saved === "string") {
                // Convert comma-separated string into array first
                saved
                  .split(",")
                  .map((v) => v.trim())
                  .filter(Boolean)
                  .forEach((val) => {
                    handleChange(field.id, val, true, false, true);
                  });
              }
              break;
case "LEFT_RIGHT_BILATERAL":
case "NORMAL_ABNORMAL":
case "RANGE_OF_MOTION":
case "POSITIVE_NEGATIVE":
case "EXERCISE":
case "CUSTOM_MATRIX":

  if (typeof saved === "object" && saved !== null) {

    // ✅ ONLY for single_rom type RANGE_OF_MOTION
    if (
      field.field_type?.input_type === "RANGE_OF_MOTION" &&
      field.range_direction === "single_rom"
    ) {
      props.setPatientEmrHistory((prev) => {
        const updated = { ...prev };
        if (!updated[field.id]) updated[field.id] = {};
        Object.entries(saved).forEach(([optionId, val]) => {
          updated[field.id][optionId] = String(val);
        });
        return updated;
      });
      break;
    }

    // ✅ ONLY for EXERCISE
    if (field.field_type?.input_type === "EXERCISE") {
      props.setPatientEmrHistory((prev) => {
        const updated = { ...prev };
        if (!updated[field.id]) updated[field.id] = {};
        Object.entries(saved).forEach(([optionId, val]) => {
          updated[field.id][optionId] = String(val);
        });
        return updated;
      });
      break;
    }

    // ✅ DEFAULT for CUSTOM_MATRIX, L/R/B, NORMAL/ABNORMAL, POS/NEG, MULTI-ROM
    const prevValue = props.patinetEmrHistory?.[field.id] || {};
    const mergedValue = { ...prevValue, ...saved };
    handleChange(field.id, mergedValue, false, false, true);
  }

  break;


            // case "CUSTOM_MATRIX":
            //   mergedState[field.id] = saved;
            //   break;

            default:
              mergedState[field.id] = saved;
          }
        });
      });
    });
  };

  const getExpandedName = (abbr) => {
    switch (abbr) {
      case "HPI":
        return "History of Present Illness (HPI)";
      case "PMH":
        return "Past Medical History (PMH)";
      case "ROS":
        return "Review of Systems (ROS)";
      default:
        return abbr;
    }
  };
  return (
    <>
      <div className="">
        <div className="card mb-2">
          {apiData?.data?.original?.data?.sub_tabs?.map((tab, tabIndex) => (
            // Loop 1: Iterate over sub_tabs
            <div key={`tab-container-${tabIndex}`} className="mb-4">
              {/* 🎯 DISPLAY SUB-TAB NAME */}
              {tab.sub_tab_name && (
                <h5 className="text-primary border-bottom pb-2 ps-2 ">
                  {getExpandedName(tab.sub_tab_name)}
                </h5>
              )}

              {tab.forms?.map((form, formIndex) => (
                // Loop 2: Iterate over forms within each tab
                <div
                  key={`form-container-${formIndex}`}
                  className="mb-3 p-3 border rounded"
                >
                  {/* 🎯 DISPLAY FORM NAME/LABEL */}
                  {(form.name || form.label) && (
                    <h5 className="text-secondary mb-3">
                      {form.name || form.label}
                    </h5>
                  )}

                  {form?.fields?.map((field, fieldIndex) => {
                    // Loop 3: Iterate over fields within each form

                    // ----------------------------------------------------
                    // CUSTOM_MATRIX RENDERING LOGIC (UNCHANGED)
                    // ----------------------------------------------------
                    if (field?.field_type?.input_type === "CUSTOM_MATRIX") {
                      const rawColumnHeader = field?.column_header || "[]";
                      let parsed = [];
                      try {
                        parsed = JSON.parse(rawColumnHeader) || [];
                      } catch {
                        parsed = [];
                      }
                      // Normalize: API may return strings or objects {color, value}
                      const columnHeaders = (Array.isArray(parsed) ? parsed : []).map((h) =>
                        typeof h === "string" ? h : (h?.value ?? String(h ?? ""))
                      );
                      const options = field?.options || [];

                      return (
                        <div
                          className="card mb-2"
                          key={`matrix-${tabIndex}-${formIndex}-${fieldIndex}`}
                        >
                          <div className="card-header sh_accordionheader">
                            <div className="d-flex flex-wrap justify-content-between align-items-center">
                              <h6 className="m-0 text-md font-weight-bold">
                                {field.label}
                              </h6>
                            </div>
                          </div>
                          <div className="card-body p-2">
                            {/* Table Section */}
                            <div className="col-12 px-0 overflow-auto">
                              {/* Desktop View (Table) */}
                              <div className="table-responsive d-none d-md-block">
                                <table className="table table-striped sh_responsivetable table-bordered mb-0 mt-3">
                                  <thead>
                                    <tr>
                                      <th>Condition</th>
                                      {columnHeaders.map(
                                        (header, headerIndex) => (
                                          <th key={headerIndex}>{header}</th>
                                        )
                                      )}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {options.map((option, index) => {
                                      {/* const name = option.value
                                        .toLowerCase()
                                        .replace(/[^a-z0-9]/g, "_"); */}
                                                                              const name = `${field.id}_${option.id}_${index}_1`;
                                        
                                      // Determine input type based on option.ismultiple
                                      const inputType =
                                        option.ismultiple == 1
                                          ? "checkbox"
                                          : "radio";

                                      // If it's a radio button, the name must be unique per row
                                      // If it's a checkbox, the name can be unique per column or remain unique per row/cell (depending on desired group logic)
                                      const inputName =
                                        inputType === "radio"
                                          ? name
                                          : `${name}_${fieldIndex}`;

                                      return (
                                        <tr key={index}>
                                          <td>{option.value}</td>
                                          {columnHeaders.map(
                                            (header, colIndex) => {
                                              const id = `${name}_${header
                                                .toLowerCase()
                                                .replace(/[^a-z0-9]/g, "_")}`;
                                              return (
                                                <td key={colIndex}>
                                                  <div className="form-check">
                                                    <input
                                                      className="form-check-input"
                                                      type={inputType} // Dynamic type
                                                      name={inputName} // Use row name for radio buttons, unique name for checkboxes
                                                      id={id}
                                                      checked={
                                                        option.ismultiple == 1
                                                          ? Array.isArray(
                                                              props
                                                                .patinetEmrHistory?.[
                                                                field.id
                                                              ]?.[option.id]
                                                            )
                                                            ? props
                                                                .patinetEmrHistory?.[
                                                                field.id
                                                              ]?.[option.id].includes(
                                                                header
                                                              )
                                                            : false // checkbox not checked
                                                          : props
                                                              .patinetEmrHistory?.[
                                                              field.id
                                                            ]?.[option.id] ===
                                                            header // radio button checked
                                                      }
                                                      onChange={(e) => {
                                                        const checked =
                                                          e.target.checked;

                                                        props.setPatientEmrHistory(
                                                          (prev) => {
                                                            const updated = {
                                                              ...prev,
                                                            };
                                                            if (
                                                              !updated[field.id]
                                                            )
                                                              updated[
                                                                field.id
                                                              ] = {};
                                                            const fieldData = {
                                                              ...updated[
                                                                field.id
                                                              ],
                                                            };

                                                            // Handle multi vs single selection logic
                                                            if (
                                                              option.ismultiple ==
                                                              1
                                                            ) {
                                                              // ✅ Multi-select (checkbox)
                                                              const existing =
                                                                Array.isArray(
                                                                  fieldData[
                                                                    option.id
                                                                  ]
                                                                )
                                                                  ? [
                                                                      ...fieldData[
                                                                        option
                                                                          .id
                                                                      ],
                                                                    ]
                                                                  : [];
                                                              if (checked) {
                                                                if (
                                                                  !existing.includes(
                                                                    header
                                                                  )
                                                                )
                                                                  existing.push(
                                                                    header
                                                                  );
                                                              } else {
                                                                const idx =
                                                                  existing.indexOf(
                                                                    header
                                                                  );
                                                                if (idx !== -1)
                                                                  existing.splice(
                                                                    idx,
                                                                    1
                                                                  );
                                                              }
                                                              fieldData[
                                                                option.id
                                                              ] =
                                                                existing.length
                                                                  ? existing
                                                                  : [];
                                                            } else {
                                                              // ✅ Single-select (radio)
                                                              fieldData[
                                                                option.id
                                                              ] = checked
                                                                ? header
                                                                : "";
                                                            }

                                                            updated[field.id] =
                                                              fieldData;
                                                            return updated;
                                                          }
                                                        );
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              );
                                            }
                                          )}
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>

                              {/* Mobile View (Cards) */}
                              <div className="d-block d-md-none mt-3">
                                {options.map((option, index) => {
                                  {/* const name = option.value
                                    .toLowerCase()
                                    .replace(/[^a-z0-9]/g, "_"); */}
                                                                          const name = `${field.id}_${option.id}_${index}_2`;
                                  // Determine input type based on option.ismultiple
                                  const inputType =
                                    option.ismultiple === 1
                                      ? "checkbox"
                                      : "radio";
                                  const inputName =
                                    inputType === "radio"
                                      ? name
                                      : `${name}_${fieldIndex}`;

                                  return (
                                    <div
                                      key={index}
                                      className="card shadow-sm mb-2 border rounded p-2"
                                      style={{ background: "#f9f9f9" }}
                                    >
                                      <h6 className="font-weight-bold mb-2">
                                        {option.value}
                                      </h6>
                                      <div className="d-flex flex-column gap-2 ps-2">
                                        {columnHeaders.map(
                                          (header, optIndex) => {
                                            const id = `${name}_${header
                                              .toLowerCase()
                                              .replace(/[^a-z0-9]/g, "_")}`;
                                            return (
                                              <label
                                                key={optIndex}
                                                className="form-check d-flex align-items-center"
                                              >
                                                <input
                                                  className="form-check-input me-2"
                                                  type={inputType} // Dynamic type
                                                  name={inputName} // Dynamic name
                                                  id={id}
                                                    checked={
                                                        option.ismultiple == 1
                                                          ? Array.isArray(
                                                              props
                                                                .patinetEmrHistory?.[
                                                                field.id
                                                              ]?.[option.id]
                                                            )
                                                            ? props
                                                                .patinetEmrHistory?.[
                                                                field.id
                                                              ]?.[option.id].includes(
                                                                header
                                                              )
                                                            : false // checkbox not checked
                                                          : props
                                                              .patinetEmrHistory?.[
                                                              field.id
                                                            ]?.[option.id] ===
                                                            header // radio button checked
                                                      }
                                                  onChange={(e) => {
                                                    const checked =
                                                      e.target.checked;

                                                    props.setPatientEmrHistory(
                                                      (prev) => {
                                                        const updated = {
                                                          ...prev,
                                                        };
                                                        if (!updated[field.id])
                                                          updated[field.id] =
                                                            {};
                                                        const fieldData = {
                                                          ...updated[field.id],
                                                        };

                                                        // Handle multi vs single selection logic
                                                        if (
                                                          option.ismultiple == 1
                                                        ) {
                                                          // ✅ Multi-select (checkbox)
                                                          const existing =
                                                            Array.isArray(
                                                              fieldData[
                                                                option.id
                                                              ]
                                                            )
                                                              ? [
                                                                  ...fieldData[
                                                                    option.id
                                                                  ],
                                                                ]
                                                              : [];
                                                          if (checked) {
                                                            if (
                                                              !existing.includes(
                                                                header
                                                              )
                                                            )
                                                              existing.push(
                                                                header
                                                              );
                                                          } else {
                                                            const idx =
                                                              existing.indexOf(
                                                                header
                                                              );
                                                            if (idx !== -1)
                                                              existing.splice(
                                                                idx,
                                                                1
                                                              );
                                                          }
                                                          fieldData[option.id] =
                                                            existing.length
                                                              ? existing
                                                              : [];
                                                        } else {
                                                          // ✅ Single-select (radio)
                                                          fieldData[option.id] =
                                                            checked
                                                              ? header
                                                              : "";
                                                        }

                                                        updated[field.id] =
                                                          fieldData;
                                                        return updated;
                                                      }
                                                    );
                                                  }}
                                                />
                                                {header}
                                              </label>
                                            );
                                          }
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    } else if (field?.field_type?.input_type === "TEXT_FIELD") {
                      return (
                        <div
                          className="card mb-2"
                          key={`text-${tabIndex}-${formIndex}-${fieldIndex}`}
                        >
                          <div className="card-header sh_accordionheader">
                            {/* 🎯 New Label Structure */}
                            <div className="d-flex flex-wrap justify-content-between align-items-center">
                              <h6 className="m-0 text-md font-weight-bold">
                                {field.label}
                              </h6>
                            </div>
                          </div>
                          <div className="card-body p-2">
                            <input
                              type="text"
                              className="form-control"
                              value={props.patinetEmrHistory?.[field.id] ?? ""}
                              // Using fieldIndex only for local ID uniqueness within this scope
                              id={`input-${fieldIndex}`}
                              placeholder={`Enter ${field.label}`}
                              onChange={(e) => {
                                handleChange(field.id, e.target.value);
                              }}
                            />
                          </div>
                        </div>
                      );
                    } else if (field?.field_type?.input_type === "TEXT_AREA") {
                      return (
                        <div
                          className="card mb-2"
                          key={`textarea-${tabIndex}-${formIndex}-${fieldIndex}`}
                        >
                          <div className="card-header sh_accordionheader">
                            <div className="d-flex flex-wrap justify-content-between align-items-center">
                              <h6 className="m-0 text-md font-weight-bold">
                                {field.label}
                              </h6>
                            </div>
                          </div>
                          <div className="card-body p-2">
                            <textarea
                              className="form-control"
                              id={`textarea-${fieldIndex}`}
                              value={props.patinetEmrHistory?.[field.id] ?? ""}
                              placeholder={`Enter detailed notes for ${field.label}`}
                              rows="3" // Added rows attribute for better usability
                              onChange={(e) => {
                                handleChange(field.id, e.target.value);
                              }}
                            />
                          </div>
                        </div>
                      );
                    } else if (
                      field?.field_type?.input_type === "MULTI_SELECT"
                    ) {
                      const options = field?.options || [];
                      const groupName = `multiselect-${fieldIndex}`;

                      return (
                        <div
                          className="card mb-2"
                          key={`multiselect-${tabIndex}-${formIndex}-${fieldIndex}`}
                        >
                          <div className="card-header sh_accordionheader">
                            <div className="d-flex flex-wrap justify-content-between align-items-center">
                              <h6 className="m-0 text-md font-weight-bold">
                                {field.label} {/* Display the main label */}
                              </h6>
                            </div>
                          </div>
                          <div className="card-body p-2">
                            {/* Start of the responsive grid structure */}
                            <div className="col-12 ">
                              <div className="row">
                                {options.map((option, optionIndex) => (
                                  <div
                                    key={optionIndex}
                                    className="col-lg-3 col-md-6 col-12"
                                  >
                                    <div className="form-group form-check form-check-solid">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        value={option.id}
                                        checked={(
                                          props.patinetEmrHistory?.[field.id] ??
                                          ""
                                        )
                                          .toString() // ensure it's a string
                                          .split(",") // convert "1,2,3" → ["1","2","3"]
                                          .includes(option.id)}
                                        onChange={(e) =>
                                          handleChange(
                                            field.id,
                                            option.id,
                                            true,
                                            false,
                                            e.target.checked
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`${groupName}-${optionIndex}`}
                                      >
                                        {option.value}{" "}
                                        {/* Display the option value */}
                                      </label>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                            {/* End of the responsive grid structure */}
                          </div>
                        </div>
                      );
                    } else if (
                      field?.field_type?.input_type === "SINGLE_SELECT"
                    ) {
                      const options = field?.options || [];
                      // Crucially, all radio buttons in a group must share the same 'name'
                      const groupName = `singleselect-${tabIndex}-${formIndex}-${fieldIndex}`;

                      return (
                        <div
                          className="card mb-2"
                          key={`singleselect-${tabIndex}-${formIndex}-${fieldIndex}`}
                        >
                          <div className="card-header sh_accordionheader">
                            <div className="d-flex flex-wrap justify-content-between align-items-center">
                              <h6 className="m-0 text-md font-weight-bold">
                                {field.label} {/* Display the main label */}
                              </h6>
                            </div>
                          </div>
                          <div className="card-body p-2">
                            {/* Start of the responsive grid structure */}
                            <div className="col-12 ">
                              <div className="row">
                                {options.map((option, optionIndex) => (
                                  <div
                                    key={optionIndex}
                                    className="col-lg-3 col-md-6 col-12"
                                  >
                                    <div className="form-group form-check form-check-solid">
                                      <input
                                        className="form-check-input"
                                        type="radio" // Changed to radio
                                        id={`${groupName}-${optionIndex}`}
                                        name={groupName} // Same name ensures only one can be selected
                                        value={option.value}
                                        checked={
                                          props.patinetEmrHistory?.[
                                            field.id
                                          ] === option.id
                                        }
                                        onChange={(e) =>
                                          handleChange(
                                            field.id,
                                            option.id,
                                            false,
                                            true,
                                            e.target.checked
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`${groupName}-${optionIndex}`}
                                      >
                                        {option.value}{" "}
                                        {/* Display the option value */}
                                      </label>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                            {/* End of the responsive grid structure */}
                          </div>
                        </div>
                      );
                    } else if (field?.field_type?.input_type === "DATE") {
                      return (
                        <div
                          className="card mb-2"
                          key={`date-${tabIndex}-${formIndex}-${fieldIndex}`}
                        >
                          <div className="card-header sh_accordionheader">
                            <div className="d-flex flex-wrap justify-content-between align-items-center">
                              <h6 className="m-0 text-md font-weight-bold">
                                {field.label} {/* Display the main label */}
                              </h6>
                            </div>
                          </div>
                          <div className="card-body p-2">
                            <FormInputs
                              type="Date" // This enables the native date picker UI
                              className="form-control"
                              id={`date-input-${fieldIndex}`}
                              value={props.patinetEmrHistory?.[field.id] ?? ""}
                              changeHandler={(value) => {
                                handleChange(field.id, value);
                              }}
                            />
                          </div>
                        </div>
                      );
                    } else if (
                      field?.field_type?.input_type === "LEFT_RIGHT_BILATERAL"
                    ) {
                      // Fixed column headers for L/R/B
                      const columnHeaders = ["Left", "Right", "Bilateral"];
                      const options = field?.options || [];

                      return (
                        <div
                          className="card mb-2"
                          key={`lrb-${tabIndex}-${formIndex}-${fieldIndex}`}
                        >
                          <div className="card-header sh_accordionheader">
                            <div className="d-flex flex-wrap justify-content-between align-items-center">
                              <h6 className="m-0 text-md font-weight-bold">
                                {field.label}
                              </h6>
                            </div>
                          </div>

                          <div className="card-body p-2">
                            {/* Table Section */}
                            <div className="col-12 px-0 overflow-auto">
                              {/* Desktop View (Table) */}
                              <div className="table-responsive d-none d-md-block">
                                <table className="table table-striped sh_responsivetable table-bordered mb-0 mt-3">
                                  <thead>
                                    <tr>
                                      <th>Condition</th>
                                      {columnHeaders.map(
                                        (header, headerIndex) => (
                                          <th key={headerIndex}>{header}</th>
                                        )
                                      )}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {options.map((option, index) => {
                                      // Name must be unique per row for radio button grouping
                                      // const name = option.value
                                      //   .toLowerCase()
                                      //   .replace(/[^a-z0-9]/g, "_");
                                      const name = `${field.id}_${option.id}_${index}_1`;
                                      return (
                                        <tr key={index}>
                                          <td>{option.value}</td>
                                          {columnHeaders.map(
                                            (header, colIndex) => {
                                              const id = `${name}_${header.toLowerCase()}`;
                                              return (
                                                <td key={colIndex}>
                                                  <div className="form-check">
                                                    <input
                                                      className="form-check-input"
                                                      type="radio"
                                                      name={name} // Ensures only one radio per row can be selected
                                                      id={id}
                                                      checked={
                                                        props
                                                          .patinetEmrHistory?.[
                                                          field.id
                                                        ]?.[option.id] ===
                                                        header.toUpperCase()
                                                      }
                                                      onChange={(e) => {
                                                        // Build nested structure manually
                                                        const prevValue =
                                                          props
                                                            .patinetEmrHistory?.[
                                                            field.id
                                                          ] || {};
                                                        const updatedFieldValue =
                                                          {
                                                            ...prevValue,
                                                            [option.id]:
                                                              header.toUpperCase(), // store option.id : header
                                                          };

                                                        // Pass that object as "value" to handleChange
                                                        handleChange(
                                                          field.id,
                                                          updatedFieldValue,
                                                          false,
                                                          false,
                                                          e.target.checked
                                                        );
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              );
                                            }
                                          )}
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>

                              {/* Mobile View (Cards) */}
                              <div className="d-block d-md-none mt-3">
                                {options.map((option, index) => {
                                  {
                                    /* const name = option.value
                                    .toLowerCase()
                                    .replace(/[^a-z0-9]/g, "_"); */
                                  }
                                  const name = `${field.id}_${option.id}_${index}_2`;
                                  return (
                                    <div
                                      key={index}
                                      className="card shadow-sm mb-2 border rounded p-2"
                                      style={{ background: "#f9f9f9" }}
                                    >
                                      <h6 className="font-weight-bold mb-2">
                                        {option.value}
                                      </h6>

                                      <div className="d-flex flex-column gap-2 ps-2">
                                        {columnHeaders.map(
                                          (header, optIndex) => {
                                            const id = `${name}_${header.toLowerCase()}`;
                                            return (
                                              <label
                                                key={optIndex}
                                                className="form-check d-flex align-items-center"
                                              >
                                                <input
                                                  className="form-check-input me-2"
                                                  type="radio"
                                                  name={name} // Ensures only one radio per row can be selected
                                                  id={id}
                                                  checked={
                                                    props.patinetEmrHistory?.[
                                                      field.id
                                                    ]?.[option.id] ===
                                                    header.toUpperCase()
                                                  }
                                                  onChange={(e) => {
                                                    // Build nested structure manually
                                                    const prevValue =
                                                      props.patinetEmrHistory?.[
                                                        field.id
                                                      ] || {};
                                                    const updatedFieldValue = {
                                                      ...prevValue,
                                                      [option.id]:
                                                        header.toUpperCase(), // store option.id : header
                                                    };

                                                    // Pass that object as "value" to handleChange
                                                    handleChange(
                                                      field.id,
                                                      updatedFieldValue,
                                                      false,
                                                      false,
                                                      e.target.checked
                                                    );
                                                  }}
                                                />
                                                {header}
                                              </label>
                                            );
                                          }
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    } else if (
                      field?.field_type?.input_type === "NORMAL_ABNORMAL"
                    ) {
                      // Fixed column headers for Normal/Abnormal
                      const columnHeaders = ["Normal", "Abnormal"];
                      const options = field?.options || [];

                      return (
                        <div
                          className="card mb-2"
                          key={`na-${tabIndex}-${formIndex}-${fieldIndex}`}
                        >
                          <div className="card-header sh_accordionheader">
                            <div className="d-flex flex-wrap justify-content-between align-items-center">
                              <h6 className="m-0 text-md font-weight-bold">
                                {field.label}
                              </h6>
                            </div>
                          </div>

                          <div className="card-body p-2">
                            {/* Table Section */}
                            <div className="col-12 px-0 overflow-auto">
                              {/* Desktop View (Table) */}
                              <div className="table-responsive d-none d-md-block">
                                <table className="table table-striped sh_responsivetable table-bordered mb-0 mt-3">
                                  <thead>
                                    <tr>
                                      <th>Condition</th>
                                      {columnHeaders.map(
                                        (header, headerIndex) => (
                                          <th key={headerIndex}>{header}</th>
                                        )
                                      )}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {options.map((option, index) => {
                                      {
                                        /* const name = option.value
                                        .toLowerCase()
                                        .replace(/[^a-z0-9]/g, "_"); */
                                      }
                                      const name = `${field.id}_${option.id}`;

                                      return (
                                        <tr key={index}>
                                          <td>{option.value}</td>
                                          {columnHeaders.map(
                                            (header, colIndex) => {
                                              const id = `${name}_${header.toLowerCase()}`;
                                              return (
                                                <td key={colIndex}>
                                                  <div className="form-check">
                                                    <input
                                                      className="form-check-input"
                                                      type="radio"
                                                      name={name}
                                                      id={id}
                                                      checked={
                                                        props
                                                          .patinetEmrHistory?.[
                                                          field.id
                                                        ]?.[option.id] ===
                                                        header.toUpperCase()
                                                      }
                                                      onChange={(e) => {
                                                        // Build nested structure manually
                                                        const prevValue =
                                                          props
                                                            .patinetEmrHistory?.[
                                                            field.id
                                                          ] || {};
                                                        const updatedFieldValue =
                                                          {
                                                            ...prevValue,
                                                            [option.id]:
                                                              header.toUpperCase(), // store option.id : header
                                                          };

                                                        // Pass that object as "value" to handleChange
                                                        handleChange(
                                                          field.id,
                                                          updatedFieldValue,
                                                          false,
                                                          false,
                                                          e.target.checked
                                                        );
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              );
                                            }
                                          )}
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>

                              {/* Mobile View (Cards) */}
                              <div className="d-block d-md-none mt-3">
                                {options.map((option, index) => {
                                  const name = option.value
                                    .toLowerCase()
                                    .replace(/[^a-z0-9]/g, "_");

                                  return (
                                    <div
                                      key={index}
                                      className="card shadow-sm mb-2 border rounded p-2"
                                      style={{ background: "#f9f9f9" }}
                                    >
                                      <h6 className="font-weight-bold mb-2">
                                        {option.value}
                                      </h6>
                                      <div className="d-flex flex-column gap-2 ps-2">
                                        {columnHeaders.map(
                                          (header, optIndex) => {
                                            const id = `${name}_${header.toLowerCase()}`;
                                            return (
                                              <label
                                                key={optIndex}
                                                className="form-check d-flex align-items-center"
                                              >
                                                <input
                                                  className="form-check-input me-2"
                                                  type="radio"
                                                  name={name}
                                                  id={id}
                                                  checked={
                                                    props.patinetEmrHistory?.[
                                                      field.id
                                                    ]?.[option.id] ===
                                                    header.toUpperCase()
                                                  }
                                                  onChange={(e) => {
                                                    // Build nested structure manually
                                                    const prevValue =
                                                      props.patinetEmrHistory?.[
                                                        field.id
                                                      ] || {};
                                                    const updatedFieldValue = {
                                                      ...prevValue,
                                                      [option.id]:
                                                        header.toUpperCase(), // store option.id : header
                                                    };

                                                    // Pass that object as "value" to handleChange
                                                    handleChange(
                                                      field.id,
                                                      updatedFieldValue,
                                                      false,
                                                      false,
                                                      e.target.checked
                                                    );
                                                  }}
                                                />
                                                {header}
                                              </label>
                                            );
                                          }
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    } else if (
                      field?.field_type?.input_type === "RANGE_OF_MOTION" &&
                      field.range_direction === "left_right_rom"
                    ) {
                      const options = field?.options || [];
                      const measurementHeaders = ["Left", "Right"];

                      return (
                        <div
                          className="card mb-2"
                          key={`rom-${tabIndex}-${formIndex}-${fieldIndex}`}
                        >
                          <div className="card-header sh_accordionheader">
                            <div className="d-flex flex-wrap justify-content-between align-items-center">
                              <h6 className="m-0 text-md font-weight-bold">
                                {field.label}
                              </h6>
                            </div>
                          </div>

                          <div className="card-body p-2">
                            {/* Desktop View (Table) */}
                            <div className="col-12 px-0 overflow-auto d-none d-md-block">
                              <table className="table table-striped sh_responsivetable table-bordered mb-0 mt-3">
                                <thead>
                                  <tr>
                                    <th>Motion</th>
                                    {measurementHeaders.map(
                                      (header, headerIndex) => (
                                        <th
                                          key={headerIndex}
                                          className="text-center"
                                        >
                                          {header}
                                        </th>
                                      )
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  {options.map((option, index) => {
                                    const baseName = option.value
                                      .toLowerCase()
                                      .replace(/[^a-z0-9]/g, "_");
                                    // Access min_value and max_value from the option object
                                    const normalRange = `${
                                      option.min_value || "0"
                                    } - ${option.max_value || "0"}`;

                                    return (
                                      <tr key={index}>
                                        <td className="font-weight-bold">
                                          {option.value}
                                          {/* Display the option-specific normal range */}
                                          <span className="text-muted d-block small">
                                            {" "}
                                            (Normal: {normalRange})
                                          </span>
                                        </td>

                                        {/* Left Input */}
                                        <td>
                                          <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            name={`${baseName}_left`}
                                            placeholder="Enter Value"
                                            value={
                                              props.patinetEmrHistory?.[
                                                field.id
                                              ]?.[option.id]?.left || ""
                                            }
                                            onChange={(e) => {
                                              const val = e.target.value;
                                              const prevField =
                                                props.patinetEmrHistory?.[
                                                  field.id
                                                ] || {};
                                              const prevOption =
                                                prevField?.[option.id] || {};

                                              const updatedFieldValue = {
                                                ...prevField,
                                                [option.id]: {
                                                  ...prevOption,
                                                  left: val, // update left value
                                                },
                                              };

                                              handleChange(
                                                field.id,
                                                updatedFieldValue,
                                                false,
                                                false,
                                                val
                                              );
                                            }}
                                          />
                                        </td>
                                        {/* Right Input */}
                                        <td>
                                          <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            name={`${baseName}_right`}
                                            placeholder="Enter Value"
                                            value={
                                              props.patinetEmrHistory?.[
                                                field.id
                                              ]?.[option.id]?.right || ""
                                            }
                                            onChange={(e) => {
                                              const val = e.target.value;
                                              const prevField =
                                                props.patinetEmrHistory?.[
                                                  field.id
                                                ] || {};
                                              const prevOption =
                                                prevField?.[option.id] || {};

                                              const updatedFieldValue = {
                                                ...prevField,
                                                [option.id]: {
                                                  ...prevOption,
                                                  right: val, // update right value
                                                },
                                              };

                                              handleChange(
                                                field.id,
                                                updatedFieldValue,
                                                false,
                                                false,
                                                val
                                              );
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>

                            {/* Mobile View (Cards) */}
                            <div className="d-block d-md-none mt-3">
                              {options.map((option, index) => {
                                const baseName = option.value
                                  .toLowerCase()
                                  .replace(/[^a-z0-9]/g, "_");
                                // Access min_value and max_value from the option object
                                const normalRange = `${
                                  option.min_value || "0"
                                } - ${option.max_value || "0"}`;

                                return (
                                  <div
                                    key={index}
                                    className="card shadow-sm mb-3 border rounded p-2"
                                  >
                                    <h6 className="font-weight-bold mb-2">
                                      {option.value}
                                      {/* Display the option-specific normal range */}
                                      <small className="text-muted d-block">
                                        {" "}
                                        (Normal: {normalRange})
                                      </small>
                                    </h6>

                                    {/* Left Input */}
                                    <div className="mb-2">
                                      <label className="d-block small">
                                        Left
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        name={`${baseName}_left`}
                                        placeholder="Enter Left ROM"
                                        value={
                                          props.patinetEmrHistory?.[field.id]?.[
                                            option.id
                                          ]?.left || ""
                                        }
                                        onChange={(e) => {
                                          const val = e.target.value;
                                          const prevField =
                                            props.patinetEmrHistory?.[
                                              field.id
                                            ] || {};
                                          const prevOption =
                                            prevField?.[option.id] || {};

                                          const updatedFieldValue = {
                                            ...prevField,
                                            [option.id]: {
                                              ...prevOption,
                                              left: val, // update left value
                                            },
                                          };

                                          handleChange(
                                            field.id,
                                            updatedFieldValue,
                                            false,
                                            false,
                                            val
                                          );
                                        }}
                                      />
                                    </div>

                                    {/* Right Input */}
                                    <div>
                                      <label className="d-bk small">
                                        Right
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        name={`${baseName}_right`}
                                        placeholder="Enter Right ROM"
                                        value={
                                          props.patinetEmrHistory?.[field.id]?.[
                                            option.id
                                          ]?.right || ""
                                        }
                                        onChange={(e) => {
                                          const val = e.target.value;
                                          const prevField =
                                            props.patinetEmrHistory?.[
                                              field.id
                                            ] || {};
                                          const prevOption =
                                            prevField?.[option.id] || {};

                                          const updatedFieldValue = {
                                            ...prevField,
                                            [option.id]: {
                                              ...prevOption,
                                              right: val, // update right value
                                            },
                                          };

                                          handleChange(
                                            field.id,
                                            updatedFieldValue,
                                            false,
                                            false,
                                            val
                                          );
                                        }}
                                      />
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      );
                    } else if (
                      field?.field_type?.input_type === "RANGE_OF_MOTION" &&
                      field.range_direction === "single_rom"
                    ) {
                      const options = field?.options || [];
                      const measurementHeader = ["Value"];

                      return (
                        <div
                          className="card mb-2"
                          key={`rom-single-${tabIndex}-${formIndex}-${fieldIndex}`}
                        >
                          <div className="card-header sh_accordionheader">
                            <div className="d-flex flex-wrap justify-content-between align-items-center">
                              <h6 className="m-0 text-md font-weight-bold">
                                {field.label}
                              </h6>
                            </div>
                          </div>

                          <div className="card-body p-2">
                            {/* Desktop View (Table) */}
                            <div className="col-12 px-0 overflow-auto d-none d-md-block">
                              <table className="table table-striped sh_responsivetable table-bordered mb-0 mt-3">
                                <thead>
                                  <tr>
                                    <th>Motion</th>
                                    {measurementHeader.map(
                                      (header, headerIndex) => (
                                        <th
                                          key={headerIndex}
                                          className="text-center"
                                        >
                                          {header}
                                        </th>
                                      )
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  {options.map((option, index) => {
                                    const baseName = option.value
                                      .toLowerCase()
                                      .replace(/[^a-z0-9]/g, "_");
                                    const normalRange = `${
                                      option.min_value || "0"
                                    } - ${option.max_value || "0"}`;

                                    return (
                                      <tr key={index}>
                                        <td className="font-weight-bold">
                                          {option.value}
                                          <span className="text-muted d-block small">
                                            {" "}
                                            (Normal: {normalRange})
                                          </span>
                                        </td>

                                        {/* Single Input */}
                                        <td>
                                          <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            name={`${baseName}_value`}
                                            placeholder="Enter Value"
                                            value={
                                              props.patinetEmrHistory?.[
                                                field.id
                                              ]?.[option.id] || ""
                                            }
                                            onChange={(e) => {
                                              const newValue = e.target.value;
                                              props.setPatientEmrHistory(
                                                (prev) => {
                                                  const updated = { ...prev };
                                                  // Initialize field object if not present
                                                  if (!updated[field.id])
                                                    updated[field.id] = {};
                                                  updated[field.id][option.id] =
                                                    newValue;
                                                  return updated;
                                                }
                                              );
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>

                            {/* Mobile View (Cards) */}
                            <div className="d-block d-md-none mt-3">
                              {options.map((option, index) => {
                                const baseName = option.value
                                  .toLowerCase()
                                  .replace(/[^a-z0-9]/g, "_");
                                const normalRange = `${
                                  option.min_value || "0"
                                } - ${option.max_value || "0"}`;

                                return (
                                  <div
                                    key={index}
                                    className="card shadow-sm mb-3 border rounded p-2"
                                  >
                                    <h6 className="font-weight-bold mb-2">
                                      {option.value}
                                      <small className="text-muted d-block">
                                        {" "}
                                        (Normal: {normalRange})
                                      </small>
                                    </h6>

                                    {/* Single Input */}
                                    <div>
                                      <label className="d-block small">
                                        Value
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        name={`${baseName}_value`}
                                        placeholder="Enter ROM Value"
                                        value={
                                          props.patinetEmrHistory?.[field.id]?.[
                                            option.id
                                          ] || ""
                                        }
                                        onChange={(e) => {
                                          const newValue = e.target.value;
                                          props.setPatientEmrHistory((prev) => {
                                            const updated = { ...prev };
                                            // Initialize field object if not present
                                            if (!updated[field.id])
                                              updated[field.id] = {};
                                            updated[field.id][option.id] =
                                              newValue;
                                            return updated;
                                          });
                                        }}
                                      />
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      );
                    } else if (
                      field?.field_type?.input_type === "POSITIVE_NEGATIVE"
                    ) {
                      // Fixed column headers for Positive/Negative
                      const columnHeaders = ["Positive", "Negative"];
                      const options = field?.options || [];

                      return (
                        <div
                          className="card mb-2"
                          key={`pn-${tabIndex}-${formIndex}-${fieldIndex}`}
                        >
                          <div className="card-header sh_accordionheader">
                            <div className="d-flex flex-wrap justify-content-between align-items-center">
                              <h6 className="m-0 text-md font-weight-bold">
                                {field.label}
                              </h6>
                            </div>
                          </div>

                          <div className="card-body p-2">
                            {/* Table Section */}
                            <div className="col-12 px-0 overflow-auto">
                              {/* Desktop View (Table) */}
                              <div className="table-responsive d-none d-md-block">
                                <table className="table table-striped sh_responsivetable table-bordered mb-0 mt-3">
                                  <thead>
                                    <tr>
                                      <th>Condition</th>
                                      {columnHeaders.map(
                                        (header, headerIndex) => (
                                          <th key={headerIndex}>{header}</th>
                                        )
                                      )}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {options.map((option, index) => {
                                      {
                                        /* const name = option.value
                                        .toLowerCase()
                                        .replace(/[^a-z0-9]/g, "_"); */
                                      }
                                      const name = `${field.id}_${option.id}_${index}_1`;

                                      return (
                                        <tr key={index}>
                                          <td>{option.value}</td>
                                          {columnHeaders.map(
                                            (header, colIndex) => {
                                              const id = `${name}_${header.toLowerCase()}`;
                                              return (
                                                <td key={colIndex}>
                                                  <div className="form-check">
                                                    <input
                                                      className="form-check-input"
                                                      type="radio"
                                                      name={name}
                                                      id={id}
                                                      value={header.toUpperCase()}
                                                      checked={
                                                        props
                                                          .patinetEmrHistory?.[
                                                          field.id
                                                        ]?.[option.id] ===
                                                        header.toUpperCase()
                                                      }
                                                      onChange={(e) => {
                                                        const selectedValue =
                                                          e.target.value; // "Positive" or "Negative"
                                                        props.setPatientEmrHistory(
                                                          (prev) => {
                                                            const updated = {
                                                              ...prev,
                                                            };
                                                            if (
                                                              !updated[field.id]
                                                            )
                                                              updated[
                                                                field.id
                                                              ] = {};
                                                            updated[field.id][
                                                              option.id
                                                            ] = selectedValue;
                                                            return updated;
                                                          }
                                                        );
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              );
                                            }
                                          )}
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>

                              {/* Mobile View (Cards) */}
                              <div className="d-block d-md-none mt-3">
                                {options.map((option, index) => {
                                  {
                                    /* const name = option.value
                                    .toLowerCase()
                                    .replace(/[^a-z0-9]/g, "_"); */
                                  }
                                  const name = `${field.id}_${option.id}_${index}_2`;

                                  return (
                                    <div
                                      key={index}
                                      className="card shadow-sm mb-2 border rounded p-2"
                                      style={{ background: "#f9f9f9" }}
                                    >
                                      <h6 className="font-weight-bold mb-2">
                                        {option.value}
                                      </h6>
                                      <div className="d-flex flex-column gap-2 ps-2">
                                        {columnHeaders.map(
                                          (header, optIndex) => {
                                            const id = `${name}_${header.toLowerCase()}`;
                                            return (
                                              <label
                                                key={optIndex}
                                                className="form-check d-flex align-items-center"
                                              >
                                                <input
                                                  className="form-check-input me-2"
                                                  type="radio"
                                                  name={name}
                                                  id={id}
                                                  value={header.toUpperCase()}
                                                  checked={
                                                    props.patinetEmrHistory?.[
                                                      field.id
                                                    ]?.[option.id] ===
                                                    header.toUpperCase()
                                                  }
                                                  onChange={(e) => {
                                                    const selectedValue =
                                                      e.target.value; // "Positive" or "Negative"
                                                    props.setPatientEmrHistory(
                                                      (prev) => {
                                                        const updated = {
                                                          ...prev,
                                                        };
                                                        if (!updated[field.id])
                                                          updated[field.id] =
                                                            {};
                                                        updated[field.id][
                                                          option.id
                                                        ] = selectedValue;
                                                        return updated;
                                                      }
                                                    );
                                                  }}
                                                />
                                                {header}
                                              </label>
                                            );
                                          }
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    } else if (field?.field_type?.input_type === "EXERCISE") {
                      const options = field?.options || [];
                      const measurementHeader = ["Value"]; // Fixed column header for Exercise

                      return (
                        <div
                          className="card mb-2"
                          key={`exercise-${tabIndex}-${formIndex}-${fieldIndex}`}
                        >
                          <div className="card-header sh_accordionheader">
                            <div className="d-flex flex-wrap justify-content-between align-items-center">
                              <h6 className="m-0 text-md font-weight-bold">
                                {field.label}
                              </h6>
                            </div>
                          </div>

                          <div className="card-body p-2">
                            {/* Desktop View (Table) */}
                            <div className="col-12 px-0 overflow-auto d-none d-md-block">
                              <table className="table table-striped sh_responsivetable table-bordered mb-0 mt-3">
                                <thead>
                                  <tr>
                                    <th>Description</th>{" "}
                                    {/* Changed label from 'Range of Motion' */}
                                    {measurementHeader.map(
                                      (header, headerIndex) => (
                                        <th
                                          key={headerIndex}
                                          className="text-center"
                                        >
                                          {header}
                                        </th>
                                      )
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  {options.map((option, index) => {
                                    const baseName = option.value
                                      .toLowerCase()
                                      .replace(/[^a-z0-9]/g, "_");
                                    // Assuming min_value/max_value are still relevant for displaying guidance
                                    const normalRange = `${
                                      option.min_value || "0"
                                    } - ${option.max_value || "0"}`;

                                    return (
                                      <tr key={index}>
                                        <td className="font-weight-bold">
                                          {option.value}
                                          <span className="text-muted d-block small">
                                            {" "}
                                            (Standard Ranges : {normalRange})
                                          </span>
                                        </td>

                                        {/* Single Input */}
                                        <td>
                                          <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            name={`${baseName}_value`}
                                            placeholder="Enter Value"
                                            value={
                                              props.patinetEmrHistory?.[
                                                field.id
                                              ]?.[option.id] || ""
                                            }
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              props.setPatientEmrHistory(
                                                (prev) => {
                                                  const updated = { ...prev };
                                                  if (!updated[field.id])
                                                    updated[field.id] = {};
                                                  updated[field.id][option.id] =
                                                    value;
                                                  return updated;
                                                }
                                              );
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>

                            {/* Mobile View (Cards) */}
                            <div className="d-block d-md-none mt-3">
                              {options.map((option, index) => {
                                const baseName = option.value
                                  .toLowerCase()
                                  .replace(/[^a-z0-9]/g, "_");
                                const normalRange = `${
                                  option.min_value || "0"
                                } - ${option.max_value || "0"}`;

                                return (
                                  <div
                                    key={index}
                                    className="card shadow-sm mb-3 border rounded p-2"
                                  >
                                    <h6 className="font-weight-bold mb-2">
                                      {option.value}
                                      <small className="text-muted d-block">
                                        {" "}
                                        (Standard Ranges: {normalRange})
                                      </small>
                                    </h6>

                                    {/* Single Input */}
                                    <div>
                                      <label className="d-block small">
                                        Value
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        name={`${baseName}_value`}
                                        placeholder="Enter Exercise Value"
                                        value={
                                          props.patinetEmrHistory?.[field.id]?.[
                                            option.id
                                          ] || ""
                                        }
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          props.setPatientEmrHistory((prev) => {
                                            const updated = { ...prev };
                                            if (!updated[field.id])
                                              updated[field.id] = {};
                                            updated[field.id][option.id] =
                                              value;
                                            return updated;
                                          });
                                        }}
                                      />
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      );
                    }

                    // Return null for any field that is NOT a CUSTOM_MATRIX
                    return null;
                  })}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default EmrHistoryQuestions;